<div class="site-text">
    <p class="text">
        eDirectory.ch ist Teil der Aktivitäten von swissDIGIN und wird von PostFinance AG betrieben. Der technische Betrieb erfolgt im Auftrag von PostFinance AG durch die Firma xeFex AG.
    </p>
    <p class="title">
        swissDIGIN
    </p>
    <p class="text">
        Die Initiative swissDIGIN (swiss Digital Invoice) bringt den elektronischen Rechnungsaustausch zwischen Unternehmen und Organisationen (kurz: E-Invoicing) in der Schweiz voran. Dafür stellt swissDIGIN Unternehmen Know-how von neutraler Seite zur Verfügung.
        <br>
        <a href="https://www.swissdigin.ch" target="_blank">www.swissdigin.ch</a>
    </p>
    <p class="title">
        PostFinance AG
    </p>
    <p class="text">
        Als Schweizer Marktführerin im Bereich E-Rechnung digitalisiert PostFinance die Rechnungsstellung und den Rechnungsempfang ihrer Kunden seit über 20 Jahren.
        PostFinance ist sowohl E-Invoicing Service Providerin, Netzwerkpartnerin von eBill wie auch eine bei eBill angeschlossene Bank. Mit der Lösung von PostFinance können Unternehmen und Organisationen sowohl E-Rechnungen mit Geschäftspartnern austauschen als auch eBill versenden und empfangen und damit ihre Prozesse effizient gestalten. Die Geschäftskundinnen und -kunden profitieren dabei von einer ganzheitlichen Beratung und haben einen Ansprechpartner zur Verfügung, der alle Anliegen rund um das E-Invoicing abdeckt.
        <br>
        <a href="https://www.postfinance.ch/billing-solutions" target="_blank">www.postfinance.ch/billing-solutions</a>
    </p>
    <p class="title">
        xeFex AG
    </p>
    <p class="text">
        Die xeFex AG erbringt IT-Dienstleistungen in den Bereichen Programmierung, Beratung und Projektleitung.
        <br>
        <a href="https://www.xefex.ch" target="_blank">www.xefex.ch</a>
    </p>
    <p class="title">
        E-Invoicing Service Provider
    </p>
    <p class="text">
        Folgende E-Invoicing Service Provider führen die Rechnungssteller und -empfänger, die an ihr Netzwerk angeschlossen und an einer stärkeren Nutzung von E-Invoicing interessiert sind, auf eDirectory.ch auf.
    </p>
    <a class="logo" href="https://www.postfinance.ch/billing-solutions" target="_blank"><img src="/assets/images/post_finance.png" alt="postfinance logo"></a>
    <a class="logo" href="https://www.abacus.ch" target="_blank"><img src="/assets/images/abacus_full.png" alt="abacus icon"></a>
    <p class="text">
        Wenn Sie als E-Invoicing Service Provider in der Schweiz domizilierten Unternehmen und Organisationen E-Invoicing Dienstleistungen anbieten und Ihre Kunden auf eDirectory publizieren möchten, melden Sie Ihr Interesse bei PostFinance <a href="mailto:billing-solutions@postfinance.ch?subject=eDirectory">(billing-solutions@postfinance.ch)</a>. Wir werden Sie schnellstmöglich kontaktieren.
    </p>
</div>
